/** CoStar.Api.Brokers.ViewModels.ValidateEmail.ValidEmailDomainResult */
export var ValidEmailDomainResult;
(function (ValidEmailDomainResult) {
    ValidEmailDomainResult[ValidEmailDomainResult["Unknown"] = 0] = "Unknown";
    ValidEmailDomainResult[ValidEmailDomainResult["Invalid"] = 1] = "Invalid";
    ValidEmailDomainResult[ValidEmailDomainResult["ValidTooFewLocations"] = 2] = "ValidTooFewLocations";
    ValidEmailDomainResult[ValidEmailDomainResult["ValidDomainMatch"] = 3] = "ValidDomainMatch";
})(ValidEmailDomainResult || (ValidEmailDomainResult = {}));
